import { render, staticRenderFns } from "./SalesDataCard.vue?vue&type=template&id=565eb6db&scoped=true"
import script from "./SalesDataCard.vue?vue&type=script&lang=js"
export * from "./SalesDataCard.vue?vue&type=script&lang=js"
import style0 from "./SalesDataCard.vue?vue&type=style&index=0&id=565eb6db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565eb6db",
  null
  
)

export default component.exports